import './blocks/toTopForBlog.js';
import './blocks/subscription-form.js';
import './blocks/blog-swiper.js';
import './blocks/social.js';
import './blocks/dragscroll.js';
import './blocks/stickyElController.js';
import './blocks/burger-menu.js';
import './blocks/region-list.js';

import { initTabs } from './blocks/blogTabs.js';
import * as common from './common_methods.js';

const apiMethods = {
  loadMore: '/local/api/blog/get_more_articles.php',
  likeDislike: '/local/api/blog/like_dislike.php',
};

const elementsMap = {
  likesDataContainer: 'articles_marks_container',
  articleIdContainer: 'articles_unique_id_container',
  moreCardsBtn: 'more_cards_button',
  cardsContainer: 'cards_container',
  likeBtn: 'like_btn',
  dislikeBtn: 'dislike_btn',
  likeArea: 'like_area',
  likeMsg: 'like_msg',
  tagsContainer: 'blog__tags',
  blogTagClass: 'blog__tag',
  upButtonId: '#upForBlog',
};

let showMoreButton;
let cardsContainer;

let likeButton;
let dislikeButton;
let likeArea;
let likeMsg;

let upButton;

// eslint-disable-next-line object-curly-newline
let articlesMarks = {};
let articleId = 0;

const loadMoreDisabled = true;

function loadMore()
{

  const arrowToTop = document.querySelector('#upForBlog');

  showMoreButton.classList.add('active');

  if(showMoreButton.classList.contains('active') && (arrowToTop))
  {
    arrowToTop.onclick = function()
    {
      window.scrollTo(scrollX, 0);
    };
    window.addEventListener('scroll', function()
    {
      arrowToTop.hidden = (this.scrollY < document.documentElement.clientHeight);
    });
  }

  const params = {
    page: loadMorePage,
  };
  const loadMoreUrl = apiMethods.loadMore + common.objToGetParameters(params);

  common.ajaxCallWithPromise(loadMoreUrl).then(
      (data) =>
      {
        addCards(data);
      },

      // eslint-disable-next-line no-unused-vars
      (error) =>
      {
        // error
      }
  );
}

function addCards(data)
{
  cardsContainer.innerHTML += data;
  loadMorePage += 1;
}

function sendArticleMark(type = 'like')
{
  if(((type === 'like') && (articleHasLike())) || ((type === 'dislike') && (articleHasDislike())))
  {
    return;
  }
  common.ajaxCallWithPromise(apiMethods.likeDislike + '?id=' + articleId + '&type=' + type).then(
      (data) =>
      {
        const parcedData = JSON.parse(data);
        if(!parcedData.error)
        {
          articlesMarks = parcedData;
          switchLikeDislikeButtons();
        }
      }
  );
}

function articleHasLike()
{
  return articlesMarks[articleId] === 'like';
}

function articleHasDislike()
{
  return articlesMarks[articleId] === 'dislike';
}

function sendLike()
{
  sendArticleMark('like');
}

function sendDislike()
{
  sendArticleMark('dislike');
}

function switchLikeDislikeButtons()
{
  if(likeButton && dislikeButton && likeArea && likeMsg)
  {
    if(articleHasLike() || articleHasDislike())
    {
      likeArea.classList.add('visually-hidden');
      likeMsg.classList.remove('visually-hidden');
    }
    else
    {
      likeArea.classList.remove('visually-hidden');
      likeMsg.classList.add('visually-hidden');
    }
  }
}

function switchTags()
{
  if(document.getElementsByClassName(elementsMap.tagsContainer)[0])
  {
    const tags = document.getElementsByClassName(elementsMap.blogTagClass);
    const url = window.location.pathname;
    let resId = 'all';

    for(let i = 0; i < tags.length; i++)
    {
      if(url.includes(tags[i].id.toLowerCase()))
      {
        resId = tags[i].id;
      }
    }
    document.getElementById(resId).classList.add('blog__tag--active');
  }
}

window.addEventListener('DOMContentLoaded', () =>
{
  initTabs();
  switchTags();
  // eslint-disable-next-line object-curly-newline
  let tempMarks = {};
  if(document.getElementById(elementsMap.likesDataContainer))
  {
    // eslint-disable-next-line object-curly-newline
    tempMarks = JSON.parse(document.getElementById(elementsMap.likesDataContainer).value) || {};
  }
  articlesMarks = tempMarks;

  if((document.getElementById(elementsMap.moreCardsBtn)) && (document.getElementById(elementsMap.cardsContainer)) && (!loadMoreDisabled))
  {
    showMoreButton = document.getElementById(elementsMap.moreCardsBtn);
    cardsContainer = document.getElementById(elementsMap.cardsContainer);

    showMoreButton.addEventListener('click', loadMore);
  }

  if(document.getElementById(elementsMap.likeBtn) && document.getElementById(elementsMap.dislikeBtn) && document.getElementById(elementsMap.likeArea) && document.getElementById(elementsMap.likeMsg))
  {
    likeButton = document.getElementById(elementsMap.likeBtn);
    dislikeButton = document.getElementById(elementsMap.dislikeBtn);

    likeArea = document.getElementById(elementsMap.likeArea);
    likeMsg = document.getElementById(elementsMap.likeMsg);

    likeButton.addEventListener('click', sendLike);
    dislikeButton.addEventListener('click', sendDislike);
  }

  const getParameters = common.getParameters(); // GET ARTICLE ID FOR MARKS
  if(getParameters.id)
  {
    articleId = getParameters.id;
  }
  else if(document.getElementById(elementsMap.articleIdContainer))
  {
    articleId = JSON.parse(document.getElementById(elementsMap.articleIdContainer).value) || 0;
  }

  switchLikeDislikeButtons();

});
